import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class KeyboardButton extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired]),
    classes: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    autofocus: PropTypes.bool,
    isDisabled: PropTypes.bool,
  };

  static defaultProps = {
    autofocus: false,
    isDisabled: false,
  };

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    // 阻止虚拟键盘获得焦点, 保留原输入框的focus状态
    if (e.target.innerText!=="确定") {
      e.preventDefault()
    }
    if (typeof (this.props.onClick) !== 'undefined') {
      this.props.onClick(this.props.value,e);
    }
  }

  render() {
    return (
      <button
        type="button"
        className={`${'keyboard-button '} ${this.props.classes || ''}`}
        onMouseDown={this.props.isDisabled ? null : this.handleClick}
        autoFocus={this.props.autofocus}
        disabled={this.props.isDisabled}
      >
        {this.props.value}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/keyboard/KeyboardButton.jsx